/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;


var LOW_BATTERY_KEY = "sent_low_battery";

module.exports = new Model({
	name: "braceletbatterynotifier",
	init: init,
	listeners: listeners,

	setFlag: setFlag,
	handle_bracelet_battery: handle_bracelet_battery,
	_initialized: false,
});

function init() {
	this.batteryBanner = retry(this.api.banner.warning.device.battery);
	this.changedBanner = retry(this.api.banner.warning.device.batterychanged);

	return AsyncStorage.getItem(LOW_BATTERY_KEY).then(function (isLow) {
		var persisted = (isLow === "true");
		this.push(persisted);

		// Detect battery readings that show up during a race condition
		var hadBattery = this._initialized;
		this._initialized = true;
		if(hadBattery !== false) {
			this.handle_bracelet_battery({
				battery: hadBattery
			});
		}
	}.bind(this));
}

function listeners() {
	return {
		"ownbraceletevents:battery": handle_bracelet_battery,
	};
}

function handle_bracelet_battery(data) {
	var battery = data.battery;
	var hasSet = this.data;
	if(!this._initialized) {
		// Account for race conditions when initializing
		this._initialized = battery;
	} else if (!hasSet && battery <= 30) {
		// post a banner indicating battery state in terms of whether the battery
		// should or has been changed.
		this.batteryBanner(battery);
		this.setFlag(true);
	// to make sure a new battery is well above a depleted level make sure it's
	// first reading is at least over 60%
	} else if (hasSet && battery > 60) {
		this.changedBanner(battery);
		this.setFlag(false);
	}
}

function setFlag(flag) {
	this.push(flag);
	AsyncStorage.setItem(LOW_BATTERY_KEY, "" + flag);
}

function retry(fn) {
	return function() {
		return fn.apply(this, arguments).catch(function(){
			return fn.apply(this, arguments);
		});
	};
}